module.exports = "<div id=\"datepicker{{$ctrl.month}}{{$ctrl.id}}\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/components/calendarComponent/calendarComponent.html
// module id = 1464
// module chunks = 0